import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { TableWrapper } from './AgGridTable.styles';
const paginationPageSizeSelector = [10, 20, 50, 100];
// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);
export const AgGridTable = ({ rowData, columnDefs, ...props }) => {
    const wrapperRef = useRef(null);
    // grid 생성 완료 시 grid height를 통해 pagination size를 조정
    const handleGridReady = useCallback((e) => {
        if (!wrapperRef.current)
            return;
        const availableHeight = wrapperRef.current.clientHeight;
        const calculatedSize = Math.floor((availableHeight - 40) / 40);
        const nextSize = paginationPageSizeSelector.find((size) => size >= calculatedSize) ?? paginationPageSizeSelector[0];
        e.api.setGridOption('paginationPageSize', nextSize);
    }, [wrapperRef]);
    return (_jsx(TableWrapper, { ref: wrapperRef, children: _jsx(AgGridReact, { rowData: rowData, columnDefs: columnDefs, pagination: true, 
            // paginationPageSize={paginationPageSize}
            paginationPageSizeSelector: paginationPageSizeSelector, overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Loading data...</span>', overlayNoRowsTemplate: '<span class="ag-overlay-loading-center">No data available</span>', 
            // 툴팁 딜레이
            tooltipShowDelay: 500, 
            // 필터링
            // quickFilterText={searchValue}
            // 셀 크기에 따른 width 자동 조절
            autoSizeStrategy: { type: 'fitGridWidth' }, 
            // 셀 드래그 가능하게
            enableCellTextSelection: true, onGridReady: handleGridReady, defaultColDef: {
                filter: true,
                tooltipField: 'value',
                tooltipComponent: 'defaultTooltip', // 기본 툴팁 컴포넌트 사용
            }, ...props }) }));
};
//# sourceMappingURL=AgGridTable.js.map